import globalStore from '$$store/main';

function onCalendarIntegrationDeleted(event) {
  if (+GT.user.id === +event.data.userId) {
    if (event.data.type === 'google') {
      globalStore.commit('integrationGoogle/removeLink', event.data.id);
    } else {
      globalStore.commit('integrationOutlook/removeLink', event.data.id);
    }
  }
}

export default onCalendarIntegrationDeleted;
